import type { IconName } from '../components/Icon';

/**
 * Settings categories, in tab order (Sodium-style bar). To add one: append it here and add its
 * panel in `panels` in SettingsPage.tsx (its Record type makes the compiler ask for it). The id is also the URL
 * hash: `/settings#microfono`, `/settings#account`...
 */
export const SETTINGS_CATEGORIES = [
  { id: 'microfono', label: 'Microfono', icon: 'mic' },
  { id: 'audio', label: 'Audio', icon: 'headphones' },
  { id: 'aspetto', label: 'Aspetto', icon: 'gear' },
  { id: 'account', label: 'Account', icon: 'users' },
  { id: 'info', label: 'Informazioni', icon: 'info' },
] as const satisfies ReadonlyArray<{ id: string; label: string; icon: IconName }>;

export type SettingsCategoryId = (typeof SETTINGS_CATEGORIES)[number]['id'];

/** Category selected by a URL hash (`#account`), falling back to the first one. */
export function categoryFromHash(hash: string): SettingsCategoryId {
  let id = hash.replace(/^#/, '').toLowerCase();
  try {
    id = decodeURIComponent(id);
  } catch {
    /* malformed escape: use it as is */
  }
  return SETTINGS_CATEGORIES.find((c) => c.id === id)?.id ?? SETTINGS_CATEGORIES[0].id;
}
